var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#eb9500;}.e,.f{fill:#b198f8;}.g{fill:#fff;filter:url(#b);}.f{opacity:.2;}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M104,86.1c-14.9,5-22.7-4.2-45.3,6.9-18,8.9-29.9-1.9-34.6-9.4-2.2-3.6-6.8-18.7,3.5-21.9C62.9,51,80.1,3.6,106.9,33.3c10.9,12,30.9,41.4-2.9,52.9Z",
    style: {
      fill: "#b198f8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 29.5,
    width: 157.4,
    height: 52,
    rx: 7.6,
    ry: 7.6,
    style: {
      fill: "#fff",
      filter: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5,51c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4h-19.8c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4h19.8m0-2h-19.8c-3.5,0-6.4,2.9-6.4,6.4h0c0,3.5,2.9,6.4,6.4,6.4h19.8c3.5,0,6.4-2.9,6.4-6.4h0c0-3.5-2.9-6.4-6.4-6.4h0Z",
    style: {
      fill: "#eb9500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 54.3,
    width: 37.7,
    height: 2.6,
    rx: 1.3,
    ry: 1.3,
    style: {
      fill: "#b198f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: 54.3,
    width: 61.7,
    height: 2.6,
    rx: 1.3,
    ry: 1.3,
    style: {
      fill: "#b198f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 43.3,
    width: 130.6,
    height: 2.6,
    rx: 1.3,
    ry: 1.3,
    style: {
      fill: "#b198f8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 65.2,
    width: 90.5,
    height: 2.6,
    rx: 1.3,
    ry: 1.3,
    style: {
      fill: "#b198f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,56.5c-.2,0-.3,0-.4-.2s-.1-.2-.1-.4,0-.4,.1-.6c0-.2,.2-.4,.5-.6,.1-.1,.2-.3,.3-.4,0,0,0-.2,0-.3,0-.3-.2-.4-.6-.4s-.4,0-.5,0c-.2,0-.3,.1-.5,.2-.2,0-.3,.1-.5,0-.1,0-.2,0-.3-.2,0-.1-.1-.2-.1-.4,0-.1,0-.3,.1-.4,0-.1,.2-.2,.4-.3,.2-.1,.5-.2,.8-.3,.3,0,.5,0,.8,0,.4,0,.8,0,1.1,.2s.5,.3,.7,.5c.2,.2,.3,.5,.3,.8s0,.5-.2,.7c-.1,.2-.3,.5-.6,.7-.3,.2-.5,.4-.6,.5,0,.1-.2,.3-.2,.4,0,0,0,.2-.2,.2s-.2,0-.3,0Zm0,2.1c-.3,0-.5,0-.6-.2s-.2-.4-.2-.6,0-.5,.2-.6c.2-.2,.4-.2,.6-.2s.5,0,.6,.2c.2,.2,.2,.4,.2,.6s0,.5-.2,.6-.4,.2-.6,.2Z",
    style: {
      fill: "#eb9500"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.1fdec6c7ac9d18ba0661b7298aff1c2e.svg";
export { ForwardRef as ReactComponent };